import url from './url';



export default url(() => '/page-not-found');
